const PatientSidebarTabs = {
  MESSAGES: 'messages',
  CALLS: 'calls',
} as const;

export type PatientSidebarTab = (typeof PatientSidebarTabs)[keyof typeof PatientSidebarTabs];
export default PatientSidebarTabs;
